module.exports = __webpack_public_path__ + "img/multiplier.473dbb18.png";